import { Product, Shop } from "../../types";
import { PRODUCT_TYPES } from "./constants";

export default {
    isSuggestionsProduct,
}

function isSuggestionsProduct(product: Product, shop: Shop) {
    for(let child of shop.productTree.childs) {
        // suggestions prod is a root menu && Upsell
        let test = child.product;
        if (test.Upsell && test.ty == PRODUCT_TYPES.Menu && product == test) {
            return true;
        }
    }
    return false;
}
